exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-cae6f4cc]{text-align:center;margin-top:15px}.btn[data-v-cae6f4cc]{margin:24px 0 0}.home[data-v-cae6f4cc]{text-align:center;margin-top:30px}.mobile-otp[data-v-cae6f4cc]{font-weight:800}.mobile-input[data-v-cae6f4cc]{border-top:0!important;border-left:0!important;border-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cae6f4cc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/auth/register2.vue
// module id = B6j9
// module chunks = 0